import { Route, RouteRecord, RawLocation } from 'vue-router';
import { Permission } from '@/models';
import { RootStore } from '@/store';

export function useOneOfPermissionRequiredStrategy(to: Route, next: (to?: RawLocation) => void) {
  const routesMatched = to.matched.filter((r: OneOfPermissionsRouteRecord) => r.meta.requiredOneOfPermissions);

  const routeRules = routesMatched.reduce((acc: Permission[], val: OneOfPermissionsRouteRecord) => {
    return acc.concat(val.meta.requiredOneOfPermissions);
  }, []);

  if (!routeRules.length) {
    return next();
  }

  const userRoles = RootStore.state.geek.current.permissions;

  if (userRoles && routeRules.every((p: Permission) => !userRoles.includes(p))) {
    return next({ name: 'error-page', params: { errorMessageKey: 'not-found' } });
  }

  next();
}

interface OneOfPermissionsRouteRecord extends RouteRecord {
  meta: { requiredOneOfPermissions: Permission[] };
}
